module.exports = __webpack_public_path__ + "img/edit_pencil.eecea726.svg";